import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import * as types from 'modules/interventions/actionTypes';

/**
 * @typedef {{
 *   isPatching: boolean,
 * }} FinalInvoiceReducer
 */

export default combineReducers({
  isPatching: loadingReducer(types.INTERVENTION_INVOICE_PATCH_STATUS),
});
